export interface AddressBookResponse {

  Oid: number | null;
  Name : string | null;
  Shared : boolean | null;
  Enabled : boolean | null;
  Type : AddressBookTypeEnum | null;
  UpdateAt : string | null;

}

export interface AddressBookListResponse {

    ItemTotal : number | null;
    Items : Array<AddressBookResponse> | null;
 
  }

export enum AddressBookTypeEnum{

    Sender = 0,
    Recipient = 1

}

export const AddressBookTypeLabelMapping: Record<AddressBookTypeEnum, string> = {
  [AddressBookTypeEnum.Sender]: "Mittente",
  [AddressBookTypeEnum.Recipient]: "Destinatario"
};
